import { Session } from '@shared/app/scripts/services/session';
import { intersection } from 'lodash';

/**
 * A directive which can be used to show or hide an element based on a user's
 * roles. This directive relies on the {@link sharedModule.currentSession}
 * to contain a roles array in order to get a list of roles.
 *
 * When multiple roles are provided, only one is required to match - OR operation.
 *
 * # Code Example
 * <code><pre>
 * $scope.disallowedRoles = ['owner'];
 * </pre></code>
 *
 * # HTML Example
 * <code><pre>
 * <button sw-disallowed="$scope.disallowedRoles">Test Button</button>
 * </pre></code>
 */
angular
  .module('coreModule')
  .directive('swDisallowed', ($parse: ng.IParseService, session: Session) => ({
    restrict: 'A',

    link: function (scope, element, attr) {
      const role = $parse(attr.swDisallowed)(scope);
      let roleMatches = false;

      session.current$.subscribe((sessionCurrent) => {
        const tenantId = sessionCurrent.tenantId;

        if (tenantId) {
          roleMatches = Boolean(
            intersection(role, sessionCurrent.roles[tenantId]).length,
          );
        }

        if (!angular.isDefined(role)) {
          element.removeClass('ng-hide');
          return;
        }

        if (tenantId && !roleMatches) {
          element.removeClass('ng-hide');
        } else if (!tenantId) {
          element.removeClass('ng-hide');
        } else {
          element.addClass('ng-hide');
        }
      });
    },
  }));
